import { render, staticRenderFns } from "./ALB.vue?vue&type=template&id=7333711a&scoped=true&"
import script from "./ALB.vue?vue&type=script&lang=js&"
export * from "./ALB.vue?vue&type=script&lang=js&"
import style0 from "./ALB.vue?vue&type=style&index=0&id=7333711a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333711a",
  null
  
)

export default component.exports